<template>
  <nd-dialog
    v-model="visible"
    close-btn
    :footer="false"
    class="vip-intro-dialog"
  >
    <bvipInfo />
    <!-- <div class="intro-list">
      <div class="intro-title">大权益介绍</div>
      <div
        v-for="(item, index) in content"
        :key="index"
        class="intro-item"
      >{{item}}</div>
    </div> -->
  </nd-dialog>
</template>

<script>
export default {
  name: 'vvipIntroDialog',
  components: {
    bvipInfo: () => import('@/view/withdraw/components/bvipInfo/index.vue')
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.vip-intro-dialog {
  /deep/.default-content {
    padding-top:0px
  }
}
.intro-list{
  padding: 0 40px 100px;
  line-height: 1.5;
  color: #666666;
  font-size: 26px;
  .intro-title{
    font-size: 38px;
    line-height: 72px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 25px;
  }
}
</style>